/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolvedSmsTemplateResponse
 */
export interface ResolvedSmsTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof ResolvedSmsTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the ResolvedSmsTemplateResponse interface.
 */
export function instanceOfResolvedSmsTemplateResponse(value: object): value is ResolvedSmsTemplateResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ResolvedSmsTemplateResponseFromJSON(json: any): ResolvedSmsTemplateResponse {
    return ResolvedSmsTemplateResponseFromJSONTyped(json, false);
}

export function ResolvedSmsTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedSmsTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ResolvedSmsTemplateResponseToJSON(json: any): ResolvedSmsTemplateResponse {
    return ResolvedSmsTemplateResponseToJSONTyped(json, false);
}

export function ResolvedSmsTemplateResponseToJSONTyped(value?: ResolvedSmsTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

